import React, { useContext } from "react";
import styled from "styled-components";
import FormWrap from "integrations/aws/common/FormWrap";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import { renderOptions } from "integrations/aws/common/Options";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import { KINESIS_LOG_TYPES } from "integrations/aws/common/constants";
import FormDataContext from "integrations/contexts/FormDataContext";
const StyledFormWrap = styled(FormWrap)`
  padding-top: 25px;
`;
const SkipHealthCheck = ({ onChange, onSubmit }) => {
  const { formData } = useContext(FormDataContext);
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Skip Health Check" }, /* @__PURE__ */ React.createElement(
    StyledFormWrap,
    {
      onSubmit,
      buttonContent: "Confirm",
      title: "Choose Log Type & Skip Health Check",
      disabled: !(formData.awsCloudWatchKinesisInputType && formData.awsCloudWatchKinesisInputType.value),
      description: /* @__PURE__ */ React.createElement("p", null, "If you're sure of the data contained within your new", " ", /* @__PURE__ */ React.createElement("strong", null, formData.awsCloudWatchKinesisStream.value), " stream, then choose your option below to skip our automated check.")
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsCloudWatchKinesisInputType",
        type: "select",
        fieldData: formData.awsCloudWatchKinesisInputType,
        onChange,
        label: "Choose AWS Input Type",
        required: true
      },
      renderOptions(KINESIS_LOG_TYPES, "Choose Log Type")
    )
  ));
};
export default SkipHealthCheck;
